import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

const ReaderCompletionFormRequirement = ({
  fontSize,
  icon,
  label,
  value
}: {
  fontSize: string;
  icon: IconProp;
  label: string;
  value?: any;
}) => {
  const { theme } = useReduxState();

  return (
    <div className="requirement">
      <div
        className="icon"
        style={
          {
            small: { fontSize: '0.8rem', padding: 3, height: 18, width: 18 },
            medium: { fontSize: '0.8rem', padding: 4, height: 20, width: 20 },
            large: { fontSize: '0.9rem', padding: 4, height: 22, width: 22 },
            huge: { fontSize: '1.1rem', padding: 5, height: 26, width: 26 }
          }[fontSize]
        }
      >
        <Icon icon={icon} fixedWidth={true} />
      </div>
      <div className="content">
        <div className="label">{label}</div>

        {value ? <div className="value">{`${value} %`}</div> : null}
      </div>

      <style jsx>{`
        .requirement {
          align-items: flex-start;
          display: flex;
          margin-top: 9px;
        }
        .icon {
          background-color: ${theme.lightGreyDark};
          border-radius: 50%;
          display: inline-block;
          font-size: 1rem;
          margin-right: 7px;
          padding: 4px 0;
          position: relative;
          text-align: center;
          top: 1px;
          height: 22px;
          width: 22px;
        }
        .label {
          display: inline-block;
          margin-right: 8px;
        }
        .value {
          display: inline-block;
          font-weight: 700;
        }
      `}</style>
    </div>
  );
};

export default ReaderCompletionFormRequirement;
